var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",attrs:{"id":"footbar"},on:{"click":function($event){return _vm.credits()}}},[_c('background'),_vm._v(" Copyright MIT Services 2020. Click Here for Attributions and Credits. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }